import React, {Component, Fragment} from 'react';
import _ from "lodash";
import Moment from 'react-moment';
import {connect} from "react-redux";
import {getPatients, addPatient, deletePatient} from "./actions";
import { getAllUsers } from "../Dentists/actions";
import CustomModalBody from '../../../../components/Patient/CustomModalBody';
import ModalComponent from '../../../../components/Modal';
import Notice from '../../../../components/Notification/newNotification';
import ViewHeader from '../view-header';
import ReactTooltip from 'react-tooltip';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {Link} from "react-router-dom";
import { globals } from '../../../../../../common/constants';
import IconSpinner from 'react-icons/lib/fa/spinner';
import { getCustomFilter } from '../../../../components/CustomInput';
import { getDefaultFilters } from './helpers';
import Pagination from "rc-pagination";
import {scrollTo} from "../../../../helpers";
import FaEdit from "react-icons/lib/fa/edit";
import DentistRegistrationForm from "../../../../components/DentistRegistrationForm";
import {editPatient} from "../../User/Home/actions";

class Patients extends Component {
    constructor (props) {
        super(props);
        let locationState = this.props.history.location.state;
        const locationStateDefaults = getDefaultFilters();
        locationState = _.assign(locationStateDefaults, locationState);
        this.state = {
            option: {
                noDataText: 'No patient is available yet.',
                hideSizePerPage: true,
                sizePerPage: globals.patientsPerPage,
                page: locationState.pageNumber,
                onSortChange: (field, order) => this.changeSortingOptions(field, order),
                onPageChange: (page) => this.handlePageChange(page),
                expandBodyClass: "tr-opened",
                onExpand: (rowId, isExpand) => {
                    if (isExpand) {
                        return this.setState({ selectedRowId: rowId });
                    }
                    this.setState({ selectedRowId: null });
                }
            },
            dentist: '',
            addPatientModal: false,
            openEditModal:false,
            deletePatientModal: false,
            deletedPatientId: '',
            validateNewPatient: {
                first_name: true,
                last_name: true,
                dentist_id: true
            },
            statuses: {
                active : 'active',
                archived: 'archived'
            },
            newPatient: {
                first_name: '',
                dentist_id: '',
                last_name: '',
                notes: ''
            },
            filterData: {
                filterOptions: locationState.filterData.filterOptions,
                sortingOptions: locationState.filterData.sortingOptions
            },
            editPatientInfo: {
                id: null,
                first_name: '',
                last_name: '',
                notes:'',
            },
            editPatientId:0,
            selectedRowId: null
        }
    }

    componentDidMount () {
        document.title = "Patient List";
        const page = this.state.option.page;
        const { filterOptions, sortingOptions } = this.state.filterData;
        this.props.getPatients(page, filterOptions, sortingOptions);
        this.props.getAllDentists()
        this.interval = setInterval(() => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getPatients(page, filterOptions, sortingOptions);
        }, 7000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    dateFormatter = (cell) => {
        return (
            <Moment format="DD/MM/YYYY">
                { cell }
            </Moment>
        );
    }

    ActionFormatter = (row, cell) => {
        if (cell.status === 'archieved') return;
        return (
            <div style={{display: 'flex' }}>
                <button data-tip="Edit Patient" className="btn edit-action" onClick={(event) => this.openEditModal(event, cell)}>
                    <span className="kr kr-edit" />
                </button>
                <button data-tip="Delete" className="btn delete-action" onClick={(event) => this.deletePatient(event, cell.id)}>
                    <span className="kr kr-delete" />
                </button>
                <ReactTooltip place="top" type="light" effect="float" />
            </div>
        );
    }

    openAddPatientModal = () => {
        this.setState({
            addPatientModal: !this.state.addPatientModal,
            validateNewPatient: {
                first_name: true,
                last_name: true,
                dentist_id: true,
            },
            newPatient: {
                first_name: '',
                last_name: '',
                dentist_id: '',
            }
        })
    }

    openEditModal = (event, row) => {
        this.setState({
            openEditModal: true,
            editPatientInfo: Object.assign(this.state.editPatientInfo, {id: row.id, first_name: row.first_name, last_name: row.last_name, notes: row.note }),
        })
    }

    handleChange = (key, value) => {
        this.setState({
            newPatient: {
                ...this.state.newPatient, [key]: value
            }
        })
        this.setState(prevState => ({
            validateNewPatient: {
                ...prevState.validateNewPatient,
                [key]:value,
            }
        }))
    }

    handleChangeDentist = (selectedOption) => {
        this.setState({
            dentist: selectedOption,
            newPatient: Object.assign(this.state.newPatient, {dentist_id: selectedOption ? selectedOption.value: ''})
        });
        this.setState(prevState => ({
            validateNewPatient: {
                ...prevState.validateNewPatient,
                dentist_id: !!selectedOption.value,
            }
        }))
    }

    handleAddNewPatient = () => {
        const { newPatient } = this.state;
        const first_name = !!newPatient.first_name;
        const last_name = !!newPatient.last_name;
        const dentist_id = !!newPatient.dentist_id;
        if (!first_name || !last_name || !dentist_id) {
            this.setState({
                validateNewPatient: {
                    first_name: first_name,
                    last_name: last_name,
                    dentist_id: dentist_id,
                }
            })
        } else {
            this.props.addPatient(newPatient);
        }
    }

    deletePatient = (event, patientId) => {
        if (this.state.deletePatientModal) {
            this.props.deletePatient(patientId, this.state.option.page, this.state.filterData.filterOptions, this.state.filterData.sortingOptions);
        } else {
            this.setState({
                deletePatientModal: true,
                deletedPatientId: patientId,
            });
        }
        event.stopPropagation();
    }

    handleClose = () => {
        this.setState({
            dentist: '',
            addPatientModal: false,
            deletePatientModal: false,
            deletedPatientId: '',
            validateNewPatient: {
                first_name: true,
                last_name: true,
                dentist_id: true
            },
            newPatient: {
                first_name: '',
                dentist_id: '',
                last_name: '',
                notes: ''
            }
        })
    }

    closeEditModal = () => {
        this.setState({
            openEditModal: false,
            // registerButtonDisable: false,
            // user: {email: '', first_name: '', last_name: '', username: '', password: '', id: null}
        })
    }

     componentWillReceiveProps(nextProps) {
        if (nextProps.adminPatients.patientAdded) {
            Notice.addNotification('Patient is successfully added.', 'success');
            this.setState({ addPatientModal: false,
                            newPatient: {first_name: '',last_name: '',notes: '', dentist_id: ''},
                            validateNewPatient: {first_name: true,last_name: true, dentist_id: true
            }});
        } else if(nextProps.adminPatients.patientAdded === false) {
            Notice.addNotification('Something went wrong. Please try again later.', 'error');
            this.setState({ addPatientModal: false,
                newPatient: {first_name: '',last_name: '',notes: '', dentist_id: ''},
                validateNewPatient: {first_name: true,last_name: true, dentist_id: true
                }});
        } else if(nextProps.adminPatients.patientDeleted === false) {
            Notice.addNotification('Patient has active cases.', 'error');
            this.setState({ addPatientModal: false, deletePatientModal: false,
                newPatient: {first_name: '',last_name: '',notes: '', dentist_id: ''},
                validateNewPatient: {first_name: true,last_name: true, dentist_id: true
                }});
        } else if(nextProps.adminPatients.patientDeleted) {
            Notice.addNotification('Patient is successfully deleted.', 'success');
            this.setState({ addPatientModal: false, deletePatientModal: false,
                newPatient: {first_name: '',last_name: '',notes: '', dentist_id: ''},
                validateNewPatient: {first_name: true,last_name: true, dentist_id: true
                }});
        }
     }

    patientFormatter = (cell, row) => {
        if (row.status === 'archieved') return cell;
        return <Link 
                    className="link-item"
                    to={{
                        pathname: `/sm-admin/patients/${row.id}`, 
                        state: {
                            page: '/sm-admin/patients',
                            pageName: 'Patients List', 
                            pageNumber: this.state.option.page, 
                            filterData: this.state.filterData
                    }}}>{cell}</Link>
    }

    dentistArrow = () => {
        return <div>
            <span className="kr kr-arrow" />
        </div>
    }

    dentistFormatter = (cell, row) => {
        if (row.status === 'archieved') return cell;
        return <Link 
                    className="link-item"
                    to={{
                        pathname: `/sm-admin/dentists/${row.dentist_id}`, 
                        state: {
                            page: '/sm-admin/patients',
                            pageName: 'Patients List', 
                            pageNumber: this.state.option.page, 
                            filterData: this.state.filterData
                    }}}>{cell}</Link>
    }

    afterColumnFilter = (filterConds) => {
        if(filterConds && !_.isEqual(filterConds, this.state.filterData)) {
            this.setState({filterData : filterConds})
        }
    }

    getFilterDefaultValue = (filterName) => {
        return this.state.filterData.filterOptions[filterName] ? this.state.filterData.filterOptions[filterName] : '';
    }

    changeFilterOptions = (field, value) => {
        if (field === 'id') {
            value = Number(value);
        } else {
            value = value.toLowerCase()
        }
        this.setState({
            filterData: {
                filterOptions: {
                    ...this.state.filterData.filterOptions,
                    [field]: value
                },
                sortingOptions: {
                    ...this.state.filterData.sortingOptions,
                }
            },
            option: {
                ...this.state.option,
                page: 1
            }
        }, () => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getPatients(page, filterOptions, sortingOptions);
        });
    }

    handlePageChange = (page) => {
        scrollTo(0,'smooth');
        this.setState({
            option: {
                ...this.state.option,
                page
            }
        }, () => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getPatients(page, filterOptions, sortingOptions);
        });
    }

    changeSortingOptions = (field, order) => {
        this.setState({
            filterData: {
                sortingOptions: {
                    [field]: order
                },
                filterOptions: {
                    ...this.state.filterData.filterOptions
                }
            },
            option: {
                ...this.state.option,
                page: 1
            }
        }, () => {
            const page = this.state.option.page;
            const { filterOptions, sortingOptions } = this.state.filterData;
            this.props.getPatients(page, filterOptions, sortingOptions);
        });
    }

    handelChangeEdit(key, value) {
        this.setState(prevState => ({
            editPatientInfo: {
                ...prevState.editPatientInfo,
                [key]: value
            }
        }))
    }

    getPatientById(patientId) {
        let patient = null;
        this.props.adminPatients.patientsList.find((item) => {
                if (item.id === patientId) {
                return patient = item;
            } else {
                return false;
            }
        });
        return patient;
    }

    editPatient(event, patientId) {
        if (this.state.openEditModal) {
            const firstNameExists = !!(this.state.editPatientInfo && this.state.editPatientInfo.first_name);
            const lastNameExists = !!(this.state.editPatientInfo && this.state.editPatientInfo.last_name);
            if (!firstNameExists || !lastNameExists) {
                this.setState({
                    validateNewPatient: {
                        first_name: firstNameExists,
                        last_name: lastNameExists,
                    }
                })
            } else {
                const page = this.state.option.page;
                const { filterOptions, sortingOptions } = this.state.filterData;
                this.props.editPatient(this.state.editPatientInfo);
                if (!this.props.loadingEditPatient){
                    this.props.getPatients(page, filterOptions, sortingOptions);
                    this.setState({openEditModal: false});
                    Notice.addNotification('Patient has been successfully edited.', 'success')
                }
            }
        } else {
            const patient = this.getPatientById(patientId);
            this.setState({
                openEditModal: true,
                editPatientId: patientId,
                editPatientInfo: patient,
            });
        }
        event.stopPropagation();
    }

    trClassFormat = (rowData) => {
        return `dentist-table-cursor mb-table ${this.state.selectedRowId === rowData.id ? 'active-row' : ''}`;
    }

    setFocusedField = (fieldName) => {
        this.setState({ focusedField: fieldName });
    }

    render () {
        const header = 'PATIENT LIST';
        const desc = 'The list of all patients';
        const navBig = document.body.clientWidth > globals.NAV_MIDDLE;

        const mobileTableRender = () => {
            return (
                <BootstrapTable
                    expandableRow={()=>true}
                    expandComponent={expandComponent}
                    className="dentist-mobile-table"
                    ref={e => this.table = e}
                    data={this.props.adminPatients.patientsList}
                    options={this.state.option}
                    trClassName={ this.trClassFormat }
                    fetchInfo={{dataTotalSize: this.props.adminPatients.totalCount}}
                    remote
                    responsive
                    striped
                    ignoreSinglePage
                >
                    <TableHeaderColumn
                        width="40"
                        isKey
                        dataField='id'
                        dataFormat={this.idFormatter}
                        dataSort={true}
                        sortFunc={() => 0}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            customFilterParameters: {
                                input_name: 'id',
                                focused: this.state.focusedField === 'id',
                                focus: this.setFocusedField,
                                activeClassName: 'active-field',
                                blur: () => this.setFocusedField(null),
                                placeholder: '',
                                defaultValue: this.getFilterDefaultValue('id'),
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="100"
                        dataField='full_name'
                        dataFormat={this.patientFormatter}
                        dataSort={true}
                        sortFunc={() => 0}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            customFilterParameters: {
                                input_name: 'full_name',
                                focused: this.state.focusedField === 'full_name',
                                focus: this.setFocusedField,
                                activeClassName: 'active-field',
                                blur: () => this.setFocusedField(null),
                                placeholder: '',
                                defaultValue: this.getFilterDefaultValue('full_name'),
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        Full Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="100"
                        dataField='dentist_fullname'
                        dataFormat={this.dentistFormatter}
                        dataSort={true}
                        sortFunc={() => 0}
                        filter={{
                            type: 'CustomFilter',
                            getElement: getCustomFilter,
                            customFilterParameters: {
                                input_name: 'dentist_fullname',
                                focused: this.state.focusedField === 'dentist_fullname',
                                focus: this.setFocusedField,
                                activeClassName: 'active-field',
                                blur: () => this.setFocusedField(null),
                                placeholder: '',
                                defaultValue: this.getFilterDefaultValue('dentist_fullname'),
                                changeFilterOptions: this.changeFilterOptions
                            }
                        }}
                    >
                        Dentist
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="30"
                        dataFormat={this.dentistArrow}
                    />
                </BootstrapTable>
            )
        }

        const expandComponent = (row) => {
            return <div className="tb-block table_drop_row">
                <div className="tb-block__item">
                    <span>Notes</span>
                    <span>{row.note}</span>
                </div>
                <div className="tb-block__item">
                    <span>Dentist</span>
                    <span>{row.dentist_fullname}</span>
                </div>
                <div className="tb-block__item">
                    <span>Added Date</span>
                    <span>{row.createdAt}</span>
                </div>
                <div className="tb-block__item">
                    <span>Status</span>
                    <span>{row.status}</span>
                </div>
                <div className="tb-block__action">
                    {this.ActionFormatter(row,row)}
                </div>
            </div>
        }

        return (
            <div className="view">
                <ViewHeader
                    header={header}
                    desc={desc}
                    openModal={()=>this.openAddPatientModal()}
                    openConvertModal={()=>this.openAddPatientModal()}
                    secondaryButtonName={'New Patient'}
                    showPrimary={false}
                    showSecondary={true}
                />

                <div className="view-content view-dashboard">
                    <div className="table-block">
                        <div>
                            {
                                (this.props.adminPatients.loading) ? <h1 className="text-center"><IconSpinner className="spinner"/> Loading...</h1> :
                                <Fragment>
                                    {navBig ?
                                        <BootstrapTable
                                            ref={e => this.table = e}
                                            data={this.props.adminPatients.patientsList}
                                            options={this.state.option}
                                            fetchInfo={{dataTotalSize: this.props.adminPatients.totalCount}}
                                            remote
                                            responsive
                                            striped
                                            ignoreSinglePage
                                        >
                                            <TableHeaderColumn
                                                width="100"
                                                isKey
                                                dataField='id'
                                                dataFormat={this.idFormatter}
                                                dataSort={true}
                                                sortFunc={() => 0}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    customFilterParameters: {
                                                        input_name: 'id',
                                                        placeholder: 'Search',
                                                        defaultValue: this.getFilterDefaultValue('id'),
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}>ID</TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="170"
                                                dataField='full_name'
                                                dataFormat={this.patientFormatter}
                                                dataSort={true}
                                                sortFunc={() => 0}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    customFilterParameters: {
                                                        input_name: 'full_name',
                                                        placeholder: 'Search',
                                                        defaultValue: this.getFilterDefaultValue('full_name'),
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}>Full Name</TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="150"
                                                dataField='note'
                                                dataSort={true}
                                                sortFunc={() => 0}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    customFilterParameters: {
                                                        input_name: 'note',
                                                        placeholder: 'Search',
                                                        defaultValue: this.getFilterDefaultValue('note'),
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}>Notes</TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="160"
                                                dataField='dentist_fullname'
                                                dataFormat={this.dentistFormatter}
                                                dataSort={true}
                                                sortFunc={() => 0}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    customFilterParameters: {
                                                        input_name: 'dentist_fullname',
                                                        placeholder: 'Search',
                                                        defaultValue: this.getFilterDefaultValue('dentist_fullname'),
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}>Dentist</TableHeaderColumn>
                                            <TableHeaderColumn
                                                columnClassName={"td-status"}
                                                width="140"
                                                dataField='status'
                                                dataSort={true}
                                                sortFunc={() => 0}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    customFilterParameters: {
                                                        input_name: 'status',
                                                        placeholder: 'Select Status...',
                                                        type: 'select',
                                                        statuses: this.state.statuses,
                                                        defaultValue: this.getFilterDefaultValue('status'),
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}>Status</TableHeaderColumn>
                                            <TableHeaderColumn
                                                dataField='createdAt'
                                                width="150"
                                                dataSort={true}
                                                sortFunc={() => 0}
                                                filter={{
                                                    type: 'CustomFilter',
                                                    getElement: getCustomFilter,
                                                    customFilterParameters: {
                                                        input_name: 'createdAt',
                                                        type: 'date',
                                                        defaultValue: this.getFilterDefaultValue('createdAt'),
                                                        changeFilterOptions: this.changeFilterOptions
                                                    }
                                                }}>Added Date</TableHeaderColumn>
                                            <TableHeaderColumn
                                                width="100"
                                                dataFormat={this.ActionFormatter}
                                                dataSort={false}>Actions</TableHeaderColumn>
                                        </BootstrapTable> : mobileTableRender()
                                    }
                                 </Fragment>
                            }
                            {
                                this.state.addPatientModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="New Patient"
                                    modalBody={
                                        <CustomModalBody handleChangeDentist={(selectedOption) => this.handleChangeDentist(selectedOption)}
                                                                 dentist={this.state.allDentistsList}
                                                                 selectedDentist={this.state.newPatient.dentist_id}
                                                                 createdByAdmin={true}
                                                                 handelChange={(key, value) => this.handleChange(key, value)}
                                                                 validation={this.state.validateNewPatient} />
                                    }
                                    show={this.state.addPatientModal}
                                    handleClose={() => this.openAddPatientModal()}
                                    buttonText="Add"
                                    buttonDisabled={this.props.loadingPatient}
                                    buttonFunction={() => this.handleAddNewPatient()}
                                    dialogClassName="new-patient-modal"
                                />
                            }
                            {
                                this.state.deletePatientModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Delete Patient"
                                    modalBody="Are you sure you want to permanently delete this patient ?"
                                    show={this.state.deletePatientModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Delete"
                                    buttonFunction={(event) => this.deletePatient(event, this.state.deletedPatientId)}
                                />
                            }
                            {
                                this.state.openEditModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle='Edit Patient Info'
                                    modalBody={
                                        <CustomModalBody
                                            handleChangeDentist={(key, value) => this.handelChangeEdit(key, value)}
                                            dentist={this.state.allDentistsList}
                                            createdByAdmin={true}
                                            handelChange={(key, value) => this.handelChangeEdit(key, value)}
                                            validation={this.state.validateNewPatient}
                                            editPatientInfo={this.state.editPatientInfo}
                                            disableSelectDentist={true}
                                        />
                                    }
                                    show={this.state.openEditModal}
                                    handleClose={this.closeEditModal}
                                    buttonText="Save"
                                    buttonStyle={(this.state.registerButtonDisable) ? 'no-shadow-btn btn-primary disabled' : 'no-shadow-btn btn-primary'}
                                    buttonFunction={(event) => this.editPatient(event, this.state.editPatientId)}
                                    dialogClassName="edit-patient-modal"
                                />
                            }
                            <Pagination
                                locale={{ prev_page: 'prev', next_page: 'next'}}
                                className="pagination__rc"
                                showLessItems
                                hideOnSinglePage
                                onChange={this.state.option.onPageChange}
                                current={this.state.option.page}
                                total={this.props.adminPatients.totalCount}
                                pageSize={this.state.option.sizePerPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return{
        loadingEditPatient: state.home.editPatient,
        adminPatients: state.adminPatients,
        loadingPatient: state.adminPatients.loadingPatient
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getAllDentists: ()=> dispatch(getAllUsers()),
        getPatients: (page, filterOptions, sortingOptions) => dispatch(getPatients(page, filterOptions, sortingOptions)),
        addPatient: (data) => dispatch(addPatient(data)),
        deletePatient: (patientId, page, filterOptions, sortingOptions) => dispatch(deletePatient(patientId, page, filterOptions, sortingOptions)),
        editPatient: (data) => { dispatch(editPatient(data)); },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Patients);


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Patients/index.js